@if (visible()) {
<div class="call-status-bar w-full px-3 py-2"
  [class.bg-[#0088FF]]="statusColor() === 'blue'"
  [class.bg-[#2BAA50]]="statusColor() === 'green'">
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-4">
      <img src="assets/images/phone-icon.svg" alt="phone">
      <div class="flex flex-col gap-1">
        <span class="text-white font-semibold text-sm">
            {{ userName }}
        </span>
        <span class="text-white text-xs font-normal">
          {{ label() }} 
          @if (callState() === 'connected') {
            • {{callDuration()}}
          }
        </span>
      </div>
    </div>

    <div class="flex items-center gap-3">
      @if(!isMicPermissionGranted()) {
        <button nz-button nzType="default"
          class="p-2 rounded-full bg-red-600 transition"
          (click)="createModalPermission('mic')">
          <img src="./assets/images/mic-on-white.svg" height="16" width="16" alt="mic"/>
        </button>
      }
      @if(isMicPermissionGranted()) {
        <button nz-button nzType="default" class="p-2 bg-black/50 rounded-full active:scale-95 transition" (click)="toggleMic()"
        [class]="{'bg-white': micState()}">
          <img height="16" width="16" alt="mic" [src]="micState() ? './assets/images/mic-black.svg' : './assets/images/mic-close-red.svg'" />
        </button>
      }
      <button class="p-2 bg-[#E54D2E] rounded-full hover:bg-red-600" (click)="endCall()">
        <img src="assets/images/end-call.svg" height="16" width="16" alt="hangup">
      </button>
    </div>
  </div>
</div>
}